import { DEFAULT_FONT_SIZE } from '@/constants/constants';
import { IPlaceholderField } from '@/interfaces/placeholder-field';

/**
 * The font size a field is rendered and written to the PDF with.
 * The font size control writes `fontStyle.fontSize` and the backend PDF writer
 * reads it, so it wins. Top-level `fontSize` is only a fallback: every field is
 * seeded with it from DEFAULT_CONFIG, so preferring it hid the user's choice.
 */
export const getFieldFontSize = (
  item: Pick<IPlaceholderField, 'fontSize' | 'fontStyle'> | null | undefined,
  fallback: number = DEFAULT_FONT_SIZE,
): number => item?.fontStyle?.fontSize || item?.fontSize || fallback;
